module.exports = __webpack_public_path__ + "assets/img/sf_icon7@2x.24d96f5e.png";